import AuthedHeader from '@/components/headers/AuthedHeader.vue'
import FreezoneReportCard from '@/views/ante-service-form/FreeZoneReportCard/index.vue'
import ShipRequestServices from '@/views/ante-service-form/ShipRequestServices/index.vue'
import EstDashboard from '@/views/establishment/dashboard/index.vue'
import DraftReadyToPayment from '@/views/individual/draft/ReadyToPayment.vue'
import EstRouter from '@/views/establishment/router.vue'
import EstUserManagementLanding from '@/views/establishment/user-management/landing/index.vue'
import EstUserManagementNew from '@/views/establishment/user-management/new-user/index.vue'
import EstUserManagementUpdate from '@/views/establishment/user-management/update-user/index.vue'
import EstUserManagementRouter from '@/views/establishment/user-management/router.vue'
import EstProfileRouter from '@/views/establishment/profile/router.vue'
import EstProfileLanding from '@/views/establishment/profile/landing/index.vue'
import EstProfileCard from '@/views/establishment/profile/card/index.vue'
import EstProfileDelegateCard from '@/views/establishment/profile/delegate-card/index.vue'
import EstProfileGroupInsuranceQuota from '@/views/establishment/profile/group-insurance-quota/index.vue'
import EstProfileBoxDetails from '@/views/establishment/profile/box-details/index.vue'
import EstProfileValidationGatewayDetails from '@/views/establishment/profile/validation-gateway-details/index.vue'
import EstProfileTouristWallet from '@/views/establishment/profile/establishment-tourist-wallet/index.vue'
import EstProfileTouristVisaDepositSelect from '@/views/establishment/profile/tourist-visa-deposit-select/index.vue'
import EstChildRouter from '@/views/establishment/childEstablishment/router.vue'
import EstChildFreeZoneSearch from '@/views/establishment/childEstablishment/EstChildFreeZoneSearch.vue'
import EstChildViewSearch from '@/views/establishment/childEstablishment/EstChildViewSearch.vue'
import EstAddChild from '@/views/establishment/add-child/index.vue'
import ResidencyView from '@/views/establishment/sponsored/ResidencyView.vue'
import VisaView from '@/views/establishment/sponsored/VisaView.vue'
import DocumentWallet from '@/views/establishment/sponsored/DocumentWallet.vue'
import SponsoredRequests from '@/views/establishment/sponsored/index.vue'
import EstMyRequestRouter from '@/views/establishment/my-requests/router.vue'
import EstablishmentRequests from '@/views/establishment/my-requests/EstablishmentRequests.vue'
import EstRefundRequests from '@/views/establishment/my-requests/RefundRequests.vue'
import EstReturnedRequests from '@/views/establishment/my-requests/ReturnedRequests.vue'
import EstValidateSubUsers from '@/views/establishment/validate-subusers/index.vue'

export default [
  // authenticated
  {
    path: '/establishment',
    name: 'EstLanding',
    meta: { needsAuth: true },
    components: {
      navbar: AuthedHeader,
      default: EstRouter
    },
    children: [
      {
        path: '',
        name: 'EstDashboard',
        components: {
          default: EstDashboard
        }
      },
      {
        path: 'my-requests',
        name: 'EstMyRequests',
        components: {
          default: EstMyRequestRouter
        },
        children: [
          {
            path: '',
            name: 'EstablishmentRequests',
            components: {
              default: EstablishmentRequests
            }
          },
          {
            path: 'returned',
            name: 'EstReturnedRequests',
            components: {
              default: EstReturnedRequests
            }
          },
          {
            path: 'refund',
            name: 'EstRefundRequests',
            components: {
              default: EstRefundRequests
            }
          }
        ]
      },
      {
        path: 'add-child',
        name: 'EstAddChild',
        components: {
          default: EstAddChild
        }
      },
      {
        path: 'free-zone-report-card',
        name: 'FreezoneReportCard',
        component: FreezoneReportCard
      },
      {
        path: 'ship-request-services',
        name: 'ShipRequestServices',
        component: ShipRequestServices
      },
      {
        path: 'requests-for-payment',
        name: 'EstRequestsForPayment',
        components: {
          default: DraftReadyToPayment
        }
      },
      {
        path: 'user-management',
        components: {
          default: EstUserManagementRouter
        },
        children: [
          {
            path: '',
            name: 'EstUserManagementLanding',
            components: {
              default: EstUserManagementLanding
            }
          },
          {
            path: 'add-new',
            name: 'EstUserManagementNew',
            components: {
              default: EstUserManagementNew
            }
          },
          {
            path: 'update/:email',
            name: 'EstUserManagementUpdate',
            components: {
              default: EstUserManagementUpdate
            }
          }
        ]
      },
      {
        path: 'profile',
        components: {
          default: EstProfileRouter
        },
        children: [
          {
            path: '',
            name: 'EstProfileLanding',
            components: {
              default: EstProfileLanding
            }
          },
          {
            path: 'card',
            name: 'EstProfileCard',
            component: EstProfileCard
          },
          {
            path: 'delegate-card',
            name: 'EstProfileDelegateCard',
            component: EstProfileDelegateCard
          },
          {
            path: 'group-insurance-quota',
            name: 'EstProfileGroupInsuranceQuota',
            component: EstProfileGroupInsuranceQuota
          },
          {
            path: 'box',
            name: 'EstProfileBoxDetails',
            component: EstProfileBoxDetails
          },
          {
            path: 'validation-gateway',
            name: 'EstProfileValidationGatewayDetails',
            component: EstProfileValidationGatewayDetails
          },
          {
            path: 'tourist-wallet',
            name: 'EstProfileTouristWallet',
            component: EstProfileTouristWallet
          },
          {
            path: 'tourist-deposit',
            name: 'EstProfileTouristVisaDepositSelect',
            component: EstProfileTouristVisaDepositSelect
          }
        ]
      },
      {
        path: 'child-establishment',
        components: {
          default: EstChildRouter
        },
        children: [
          {
            path: 'searchFreeZoneChildEstablishments',
            name: 'EstChildFreeZoneSearch',
            components: {
              default: EstChildFreeZoneSearch
            }
          },
          {
            path: 'viewFreeZoneChildEstablishments',
            name: 'EstChildViewSearch',
            components: {
              default: EstChildViewSearch
            }
          }
        ]
      },
      {
        path: 'child-establishment/searchCanceledChildEstablishments',
        name: 'EstChildCanceledSearch',
        components: {
          default: EstChildFreeZoneSearch
        }
      },

      {
        path: '/establishment/sponsored',
        redirect: '/establishment/sponsored/main'
      },
      {
        path: '/establishment/sponsored/canceled-files',
        name: 'EstCanceledRequests',
        components: {
          default: SponsoredRequests
        }
      },
      {
        path: '/establishment/sponsored/old-sponsored',
        name: 'EstOldSponsored',
        components: {
          default: SponsoredRequests
        }
      },
      {
        path: '/establishment/sponsored/escape-files',
        name: 'EstEscapeFiles',
        components: {
          default: SponsoredRequests
        }
      },
      {
        path: '/establishment/sponsored/canceled-escape-report',
        name: 'EstCanceledEscapeReport',
        components: {
          default: SponsoredRequests
        }
      },
      {
        path: '/establishment/sponsored/main',
        name: 'EstSponsoredRequests',
        components: {
          default: SponsoredRequests
        }
      },
      {
        path: '/establishment/residencyView',
        name: 'EstResidencyView',
        components: {
          default: ResidencyView
        }
      },
      {
        path: '/establishment/visaView',
        name: 'EstVisaView',
        components: {
          default: VisaView
        }
      },
      {
        path: '/establishment/documentsWallet',
        name: 'EstDocumentWallet',
        components: {
          default: DocumentWallet
        }
      },
      {
        path: '/validate-subusers',
        name: 'EstValidateSubUsers',
        components: {
          default: EstValidateSubUsers
        }
      }
    ]
  }
]
